"use strict";

import axios from "axios";
import Vue from "vue";
import router from "../router";
import session from "../util/session";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
const STORAGE_KEY = "token";

let config = {
  baseURL: process.env.VUE_APP_API_URL || "",
  timeout: 60 * 1000, // Timeout,
  storageKey: STORAGE_KEY,
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);
_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    let JWT_TOKEN = session.get.token();
    if (JWT_TOKEN != null) {
      config.headers.Authorization = `Bearer ${JWT_TOKEN}`;
    } else if (["auth"].indexOf(config.url) == -1) {
      throw "token_empty";
    }
    return config;
  },
  function(error) {
    if (error == "token_empty") router.push("/login");

    // Do something with request error
    return Promise.reject(error);
  }
);

let sessionExpiredNotification = false;

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    return response;
  },
  function(error) {
    // redirect to login when unautorized
    if (error.response.status == 401 && !sessionExpiredNotification) {
      sessionExpiredNotification = true;
      Vue.prototype.$dialog.notify.error(
        "Sesi telah habis, mengarahkan ke halaman login",
        {
          position: "top-right",
          timeout: 5000,
        }
      );
      setTimeout(function() {
        session.clear();
        router.push(
          "/login",
          () => {
            sessionExpiredNotification = false;
          },
          () => {
            sessionExpiredNotification = false;
          }
        );
      }, 500);
    }

    console.error(error);
    let message = error.response
      ? `${error.response.statusText} (${error.response.status})`
      : error;
    const response = error.response;
    if (response.data && response.data.Message) {
      message += `: ${response.data.Message}`;
    }
    // Do something with response error
    return Promise.reject(message);
  }
);

Plugin.install = function(Vue) {
  Vue.axios = _axios;
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      },
    },
    $axios: {
      get() {
        return _axios;
      },
    },
  });
};

Vue.use(Plugin);

export default Plugin;
